import React, { useReducer } from 'react'
import ProductContext from './productContext'
import ProductReducer from './productReducer'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import {
    GET_ALL_SEARCH,
    GET_ALL_SEARCH_MANIFEST,
    GET_SINGLE_PRODUCT,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './productTypes'

const ProductState = (props) => {
    const initialState = {
        search_allproducts: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        search_allproducts_manifest: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        single_product: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(ProductReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllSearchProducts = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'search', formData, '', `front/product`, true),
            ])
            const from = fromVariable ? fromVariable : 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_SEARCH,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                        status: res.data.status,
                        from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllSearchProductsManifest = async (formData, fromVariable) => {
        try {
            console.log('Calling..')
            const [res] = await Promise.all([
                apiCall('post', 'searchManifest', formData, '', 'product'),
            ])
            const from = fromVariable ? fromVariable : 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_SEARCH_MANIFEST,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleProduct = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'singleProduct', formData, '', `front/product`, true),
            ])
            const from = fromVariable ? fromVariable : 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_PRODUCT,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ProductContext.Provider
            value={{
                search_allproducts: state.search_allproducts,
                search_allproducts_manifest: state.search_allproducts_manifest,
                single_product: state.single_product,
                clearResponse,
                getSingleProduct,
                getAllSearchProducts,
                getAllSearchProductsManifest,
            }}
        >
            {props.children}
        </ProductContext.Provider>
    )
}

export default ProductState
